<template>
  <div class="card-box">
    <div v-if="billingCallSessionEnabled" class="pull-right text-muted">
      En session d'appel effectuez un suivi en bas de l'écran.
    </div>
    <div v-else>
      <el-tooltip class="item" content="Créer un appel téléphonique">
        <el-button class="pull-right" v-create:call="{customer: customer, reminder: getLastReminder()}"
                   style="margin-left: 10px;" type="success" icon="el-icon-plus" circle></el-button>
      </el-tooltip>

      <el-tooltip class="item" content="Saisir un commentaire manuel">
        <el-button class="pull-right" size="mini" v-create:comment="{customer_id: customer.id}" type="success" circle>
          <i class="zmdi zmdi-comment"></i>
        </el-button>
      </el-tooltip>

      <el-tooltip class="item" content="Saisir un rappel manuel">
        <el-button class="pull-right" size="mini" v-create:reminder="{customer_id: customer.id}" type="success" circle>
          <i class="zmdi zmdi-notifications"></i>
        </el-button>
      </el-tooltip>

      <el-tooltip class="item" content="Saisir une signature de propale">
        <el-button class="pull-right" size="mini" @click="openSignProposal()" type="success" circle
                   :disabled="relations.proposals.length === 0">
          <i class="zmdi zmdi-star"></i>
        </el-button>
      </el-tooltip>
    </div>

    <h4 class="header-title m-t-0 m-b-20">Suivi commercial</h4>

    <el-tabs v-model="tab">
      <el-tab-pane :label="'Timeline (' + customerComments.length + ')'" name="Timeline"></el-tab-pane>
      <el-tab-pane :label="'Devis B2B (' + customerOldComments['Devis B2B'].length + ')'"
                   name="Devis B2B"></el-tab-pane>
    </el-tabs>

    <div v-if="tab === 'Timeline'" style="padding-left: 20px;">
      <div class="pull-right">
        <el-checkbox v-model="hideNonSuccessCall">
          <span style="font-size: 12px;">Cacher les appels non aboutis</span>
        </el-checkbox>
      </div>
      <div class="timeline">
        <article
          :class="[
            'timeline-item',
            moment(items.timelineDate).format('YYYY-MM-DD HH:00') === moment().format('YYYY-MM-DD HH:00') ? 'timeline-item-now' : '',
            moment(items.timelineDate).isAfter(moment()) && (key + 1) in timeline && moment(timeline[(key + 1)].timelineDate).isBefore(moment()) ? 'timeline-item-separation' : '']"
          v-for="(items, key) in timeline">
          <div class="timeline-desk">
            <div class="panel">
              <div class="timeline-box">
                <span class="arrow"></span>
                <el-tooltip v-if="items[0].user_id" class="item" effect="dark" :content="getUserTooltip(items[0].user_id, items[0])"
                            placement="top">
                  <span class="timeline-icon" :style="getTimelineStyle(items[0])">
                    <gravatar :email="getUserEmail(items[0].user_id)" alt="user" class="img-circle"></gravatar>
                  </span>
                </el-tooltip>
                <span v-else class="timeline-icon">
                  <span><i class="fas fa-user" style="font-size: 1.7em; margin: 7px 6px;"></i></span>
                </span>
                <h4 class="m-b-10" style="font-weight: bold;" v-if="moment(items.timelineDate).format('YYYY-MM-DD HH:00') === moment().format('YYYY-MM-DD HH:00')">
                  Maintenant
                </h4>
                <h4 class="m-b-10" v-else-if="moment(items.timelineDate).format('YYYY-MM-DD HH:00') === moment().format('YYYY-MM-DD 00:00')">
                  Aujourd'hui
                </h4>
                <h4 class="m-b-10" v-else>
                  {{ items.timelineDate | moment('L') }}
                  <span class="timeline-date text-muted" v-if="moment(items.timelineDate).format('H') !== '0'">
                    <small> à {{ items.timelineDate | moment('H') }}h</small>
                  </span>
                </h4>
                <div>
                  <div v-for="item in items" :key="item.itemType + item.id">
                    <div v-if="item.itemType === 'calling'">
                      <span><i class="fas fa-sync fa-spin"></i> Appel en cours ...</span>
                    </div>
                    <div v-else-if="item.itemType === 'call'">
                      <timeline-call-widget
                        :call="item"
                      >
                      </timeline-call-widget>
                    </div>
                    <div v-else-if="item.itemType === 'reminder'" class="text-muted">
                      <span v-edit:reminder="item" style="cursor: pointer">
                        <span class="label label-pill label-default" :style="{background: item.category.color}">
                          Rappel : {{ item.category.name }}
                        </span>
                        <el-tooltip v-if="item.meeting" class="item" effect="dark"
                                    :content="'Rendez-vous à ' + moment(item.date.date).format('H:mm')" placement="top">
                          <i class="fa fa-calendar-check-o"></i>
                        </el-tooltip> {{ item.description }}
                      </span>
                    </div>
                    <div v-else-if="item.itemType === 'auto_billing_reminder'" class="text-muted">
                      <span @click="updateBillingReminder()" style="cursor: pointer">
                        <span class="label label-pill label-default" :style="{background: item.category.color}">
                          Rappel : Session d'appel facturation
                        </span>
                        <el-tooltip v-if="item.meeting" class="item" effect="dark"
                                    :content="'Rendez-vous à ' + moment(item.date.date).format('H:mm')" placement="top">
                          <i class="fa fa-calendar-check-o"></i>
                        </el-tooltip> {{ item.description }}
                      </span>
                    </div>
                    <div v-else-if="item.itemType === 'comment'" class="text-muted" style="cursor: pointer;">
                      <span v-edit:comment="item">
                        <span class="label label-pill label-info"><i style="font-size: 1.2em"
                                                                     class="zmdi zmdi-comment"></i></span>
                        <div v-html="getFormattedText(item.description)"
                             style="white-space: pre-wrap; position: relative; margin-top: -20px; margin-left: 32px;"></div>
                      </span>
                    </div>
                    <div v-else-if="item.itemType === 'proposal'" class="text-primary">
                      <span class="label label-pill label-info"><i style="font-size: 1.2em" class="zmdi zmdi-star"></i></span>
                      <span v-if="item.type_id === 1">Propale Leads</span>
                      <span v-else-if="item.type_id === 2">Propale Rendez-vous</span>
                      <span v-else-if="item.type_id === 3">Propale : {{ item.amount }} €</span>
                    </div>
                    <div v-else-if="item.itemType === 'accepted_proposal'" class="text-primary">
                      <span class="label label-pill label-info"><i style="font-size: 1.2em" class="zmdi zmdi-star"></i></span>
                      <span v-if="item.type_id === 1" style="font-weight: bold;">Signature Propale Leads</span>
                      <span v-else-if="item.type_id === 2"
                            style="font-weight: bold;">Signature Propale Rendez-vous</span>
                      <span v-else-if="item.type_id === 3" style="font-weight: bold;">Signature Propale : {{ item.amount
                        }} €</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="after-panel-separation" v-if="moment(items.timelineDate).isAfter(moment()) && (key + 1) in timeline && moment(timeline[(key + 1)].timelineDate).isBefore(moment())">
              <span class="text-muted">A venir</span>
            </div>
          </div>
        </article>
      </div>
    </div>
    <div v-else style="margin: 0 10px;">
      <div class="row m-b-10">
        <div class="col-md-1 text-center"><strong>App</strong></div>
        <div class="col-md-2 text-center"><strong>Date</strong></div>
        <div class="col-md-2 text-center"><strong>Commercial</strong></div>
        <div class="col-md-5 text-center"><strong>Description</strong></div>
        <div class="col-md-2"></div>
      </div>
      <div class="row m-b-10" v-for="comment in customerOldComments[tab]" :key="'c' + comment.id">
        <div class="col-md-1">
          <el-tooltip v-if="comment.badge && comment.badge === 'COMMERCIAL'" class="item" content="App. Commerciale"
                      placement="top">
            <div style="background-color: #64b0f2; padding: 0px; color: white; text-align: center;">
              <i class="zmdi zmdi-phone"></i>
            </div>
          </el-tooltip>
          <el-tooltip v-else-if="comment.badge && comment.badge === 'BILLING'" class="item" content="App. Facturation"
                      placement="top">
            <div style="background-color: #FFBC5E; padding: 0px; color: white; text-align: center;">
              <i class="zmdi zmdi-collection-text"></i>
            </div>
          </el-tooltip>
          <div v-else>-</div>
        </div>
        <div class="col-md-2">{{ comment.created_at | moment('DD/MM/YYYY HH:mm') }}</div>
        <div class="col-md-2">
          <span v-if="comment.user_id">
            <user :item="getUser(comment.user_id)"></user>
          </span>
          <span v-else-if="tab !== 'Devis B2B' && comment.user_name">
            {{ comment.user_name }}
          </span>
          <span v-else>-</span>
        </div>
        <div class="col-md-5" style="white-space: pre-wrap;">{{ comment.description }}</div>
        <div class="col-md-2">
          <div v-if="comment.id" class="pull-right">
            <el-button :disabled="comment.user_id !== user.id" v-edit:comment="comment" type="warning" size="mini"
                       icon="el-icon-edit" circle></el-button>
            <el-button :disabled="comment.user_id !== user.id" v-delete:comment="comment" type="danger" size="mini"
                       icon="el-icon-close" circle></el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .timeline:before {
    left: 0;
  }

  .timeline-desk {
    width: 100%;
  }

  .timeline .timeline-item-separation .panel {
    margin-bottom: 30px;
  }

  .after-panel-separation {
    border-bottom: 4px dashed rgba(129, 138, 145, 0.3);
    margin-bottom: 30px;
    text-align: center;
  }

  .after-panel-separation span {
    position: absolute;
    margin-top: -8px;
    margin-left: -50px;
    background-color: white;
    padding: 0 10px;
    text-transform: uppercase;
  }

  .timeline-item:before {
    content: '';
    display: none;
  }

  .timeline-desk .panel {
    box-shadow: 0 0px 24px 0 rgba(0, 0, 0, 0.1), 0 1px 0px 0 rgba(0, 0, 0, 0.02);
  }

  .timeline .timeline-icon {
    width: 40px;
    height: 40px;
    margin-top: -20px;
    left: -64px;
  }

  .timeline .timeline-icon img {
    width: 90%;
    margin-top: 2px;
  }

  .timeline .timeline-item-now .panel {
    background-color: #1bb99a;
    color: white;
  }

  .timeline .timeline-item-now .text-success, .timeline .timeline-item-now .text-muted {
    color: white !important;
  }
</style>

<script>
  import User from '../../../../Entities/User.vue'
  import moment from 'moment'
  import _ from 'lodash'
  import gravatar from 'vue-gravatar'
  import Reminder from "../../../../Entities/Reminder.vue"
  import {events} from '../../../../../services/event-bus'
  import TimelineCallWidget from "./TimelineCallWidget.vue"

  export default {
    components: {
      Reminder,
      User, gravatar,
      TimelineCallWidget
    },
    name: 'customer-timeline-summary-widget',
    props: ['customer', 'relations', 'interface'],
    data () {
      return {
        tab: 'Timeline',
        hideNonSuccessCall: true,
      }
    },
    methods: {
      updateBillingReminder () {
        events.emit('app/ui/billingReminder/openModal', {
          customer: this.customer
        })
      },
      getFormattedText (text) {
        return text.replace(/\*(\S(.*?\S)?)\*/gm, '<strong>$1</strong>');
      },
      getUser (id) {
        let user = this.$store.getters['users/all'].find(user => user.id === id)
        return user ? user : {
          name: 'Inconnu',
          email: ''
        }
      },
      getUserEmail (id) {
        return this.getUser(id).email
      },
      getUserTooltip (id, item) {
        let tooltip = this.getUser(id).name

        if (item.badge === 'COMMERCIAL') {
          tooltip += ' dans l\'application commerciale'
        } else if (item.badge === 'BILLING') {
          tooltip += ' dans l\'application facturation'
        }

        return tooltip
      },
      getTimelineStyle (item) {
        if (item.badge === 'COMMERCIAL') {
          return {'background-color': '#64b0f2'}
        } else if (item.badge === 'BILLING') {
          return {'background-color': '#FFBC5E'}
        } else {
          return ''
        }
      },
      getLastReminder () {
        let self = this

        let reminders = this.relations.reminders
          .filter(reminder => {
            return reminder.user_id === self.$store.getters['users/current'].id
          })

        if (this.interface === 'BILLING') {
          return reminders.filter(reminder => reminder.category_id === 4)[0]
        } else {
          return reminders.filter(reminder => reminder.category_id !== 4)[0]
        }
      },
      openSignProposal () {
        events.emit('app/proposals/sign', {
          proposals: this.relations.proposals
        })
      },
      updateAutoBillingReminder () {

      }
    },
    computed: {
      user () {
        return this.$store.getters['users/current']
      },
      timeline () {
        let calls = this.relations.calls
        let comments = this.relations.comments.filter(comment => comment.group === null)
        let proposals = this.relations.proposals
        let reminders = this.relations.reminders

        let timeline = {}
        for (let i = 0; i < calls.length; i++) {
          let dateKey = moment(calls[i].ended_at).format('YYYY-MM-DD HH:00')
          if (calls[i].successful || !this.hideNonSuccessCall) {
            if (typeof timeline[dateKey] === 'undefined') timeline[dateKey] = []
            calls[i].itemType = 'call'
            timeline[dateKey].push(calls[i])
          }
        }
        for (let i = 0; i < comments.length; i++) {
          let dateKey = moment(comments[i].created_at).format('YYYY-MM-DD HH:00')
          if (typeof timeline[dateKey] === 'undefined') timeline[dateKey] = []
          comments[i].itemType = 'comment'
          timeline[dateKey].push(comments[i])
        }
        for (let i = 0; i < proposals.length; i++) {
          let proposal = _.cloneDeep(proposals[i])
          let dateKey = moment(proposal.created_at).format('YYYY-MM-DD HH:00')
          if (typeof timeline[dateKey] === 'undefined') timeline[dateKey] = []
          proposal.itemType = 'proposal'
          timeline[dateKey].push(proposal)
        }
        for (let i = 0; i < proposals.length; i++) {
          let proposal = _.cloneDeep(proposals[i])
          if (proposal.accepted_at !== null) {
            let dateKey = moment(proposal.accepted_at).format('YYYY-MM-DD HH:00')
            if (typeof timeline[dateKey] === 'undefined') timeline[dateKey] = []
            proposal.itemType = 'accepted_proposal'
            timeline[dateKey].push(proposal)
          }
        }
        for (let i = 0; i < reminders.length; i++) {
          let dateKey = moment(reminders[i].date.date).format('YYYY-MM-DD HH:00')
          if (typeof timeline[dateKey] === 'undefined') timeline[dateKey] = []
          reminders[i].itemType = 'reminder'
          timeline[dateKey].push(reminders[i])
        }
        if ('callcenter_flag_billing_exclude_until' in this.customer.meta && this.customer.meta.callcenter_flag_billing_score > 0) {
          let dateKey = this.customer.meta.callcenter_flag_billing_priority ? moment(this.customer.meta.callcenter_flag_billing_exclude_until).format('YYYY-MM-DD HH:00') : moment(this.customer.meta.callcenter_flag_billing_exclude_until).format('YYYY-MM-DD 00:00')
          if (typeof timeline[dateKey] === 'undefined') timeline[dateKey] = []
          timeline[dateKey].push({
            itemType: 'auto_billing_reminder',
            date: {date: this.customer.meta.callcenter_flag_billing_exclude_until},
            meeting: !!this.customer.meta.callcenter_flag_billing_priority,
            category: {
              name: 'Session d\'appel facturation (relance paiement)',
              color: '#ff5d48',
            },
            description: ''
          })
        }
        if('callcenter_flag_locked_until' in this.customer.meta && moment(this.customer.meta.callcenter_flag_locked_until).isAfter(moment())) {
          let dateKey = moment().format('YYYY-MM-DD HH:00')
          if (typeof timeline[dateKey] === 'undefined') timeline[dateKey] = []
          timeline[dateKey].push({
            itemType: 'calling',
            user_id: this.customer.meta.callcenter_flag_locked_by
          })
        }

        let keys = Object.keys(timeline).sort().reverse()
        let orderedTimeline = []
        for (let i in keys) {
          timeline[keys[i]].timelineDate = keys[i]
          orderedTimeline.push(timeline[keys[i]])
        }

        return orderedTimeline
      },
      customerComments () {
        return this.relations.comments.filter(item => !item.group).slice().reverse()
      },
      customerOldComments () {
        return {
          'Devis B2B': this.relations.comments.filter(item => item.group === 'Devis B2B').slice().reverse()
        }
      },
      billingCallSessionEnabled () {
        return this.$store.state.app.ui.payload.billingCallSessionEnabled
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CustomerTimelineSummaryWidget.vue?401006c7